import { PropTypes } from 'prop-types';
import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import ButtonWithLoader from './ButtonWithLoader';

const ModalDialog = (props) => {
  const {
    children,
    title,
    isOpen,
    close,
    onReady,
    className,
    disabled,
    showFooter,
    onReadyParams,
    submitButtonText,
    cancelButtonText,
    onCancel,
    isSubmitting,
  } = props;

  const onReadyWithParams = () => {
    onReady(...onReadyParams);
  };
  const handleCancel = () => {
    if (onCancel) onCancel();
    close();
  };
  return (
    <Modal isOpen={isOpen} toggle={close} className={className}>
      <ModalHeader toggle={close} className="custom-detergent-modal-title">
        <div style={{ fontSize: 'large' }}>{title}</div>
      </ModalHeader>{' '}
      <ModalBody data-testid="modal">{children}</ModalBody>
      {showFooter && (
        <ModalFooter>
          <Button color="secondary" className="button" onClick={handleCancel}>
            {cancelButtonText || (onReady ? 'Cancel' : 'Close')}
          </Button>{' '}
          {onReady && !onReadyParams ? (
            <ButtonWithLoader
              style="button confirm"
              handleClick={onReady}
              disabled={disabled}
              isLoading={isSubmitting}
              options={{ height: '24px', width: '24px' }}
            >
              <span>{submitButtonText ? submitButtonText : 'Ok'}</span>
            </ButtonWithLoader>
          ) : onReady && onReadyParams ? (
            <ButtonWithLoader
              style="button confirm"
              handleClick={onReadyWithParams}
              disabled={disabled}
              isLoading={isSubmitting}
              options={{ height: '24px', width: '24px' }}
            >
              <span>{submitButtonText ? submitButtonText : 'Ok'}</span>
            </ButtonWithLoader>
          ) : null}
        </ModalFooter>
      )}
    </Modal>
  );
};

ModalDialog.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  title: PropTypes.string.isRequired,
  onReady: PropTypes.func,
  close: PropTypes.func.isRequired,
  isOpen: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
  showFooter: PropTypes.bool,
  onReadyParams: PropTypes.arrayOf(PropTypes.any),
  submitButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string,
  onCancel: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

ModalDialog.defaultProps = {
  showFooter: true,
};

export default ModalDialog;
